import React from 'react'
import './Footer.css'
function Footer() {
  return (
    <div className='footer'>
        <p>2022 COP3530 AirBnBeast Project</p>
        
    </div>
  )
}

export default Footer